import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import Picture from './Picture';
import Button from '../Link/Button';
import Header from '../Type/Header';
import Blockquote from '../Type/Blockquote';
import Eyebrow from '../Type/Eyebrow';
import Caption from '../Type/Caption';
import UnorderedList from '../Type/UnorderedList';

import './Card.module.css';

class Card extends PureComponent {
  render() {
    const {
      image,
      headline,
      classes,
      children,
      imageCaption,
      eyebrowText,
      ctaLocation,
      ctaText,
      ctaColor,
      blockquote,
      listItems,
      labelText,
      overlayText,
      bgColor,
      padding,
      bgImage
    } = this.props;
    return (
      <div
        styleName="card"
        className={classes}
        style={{
          backgroundColor: bgColor,
          padding,
          backgroundImage: `url(${bgImage})`
        }}
      >
        <div styleName="card-image">
          {labelText && <div styleName="label-1">{labelText}</div>}
          <div styleName="overlay" />
          <div styleName="text-overlay">
            <p>{overlayText}</p>
          </div>
          {image ? (
            <Picture largeImage={image} width="100%" height={300} />
          ) : (
            ''
          )}
        </div>
        <div styleName="card-body">
          <Caption>{imageCaption}</Caption>
          <Eyebrow styleName="label-2">{eyebrowText}</Eyebrow>
          <Header level={3} displayAs={4}>
            {headline}
          </Header>
          <div styleName="content">{children}</div>
          {ctaLocation === 'Button' && (
            <Button color={ctaColor}>{ctaText}</Button>
          )}
          {ctaLocation === 'Tertiary' && (
            <div styleName="tertiary-cta">{ctaText}</div>
          )}
          <Blockquote>{blockquote}</Blockquote>
          {listItems && (
            <UnorderedList>
              {listItems}
              <p>one</p>
            </UnorderedList>
          )}
        </div>
        {ctaLocation === 'Bottom' && (
          <div styleName="full-bleed-cta">{ctaText}</div>
        )}
      </div>
    );
  }
}

Card.propTypes = {
  /** The large image URL */
  image: PropTypes.string,
  /** Headline title */
  headline: PropTypes.string.isRequired,
  classes: PropTypes.any,
  children: PropTypes.node,
  imageCaption: PropTypes.string,
  eyebrowText: PropTypes.string,
  ctaLocation: PropTypes.string,
  ctaText: PropTypes.string,
  ctaColor: PropTypes.string,
  blockquote: PropTypes.string,
  listItems: PropTypes.object,
  labelText: PropTypes.string,
  overlayText: PropTypes.string,
  bgColor: PropTypes.string,
  padding: PropTypes.string,
  bgImage: PropTypes.string
};

export default DisplayComponent(Card);
